export function isQRIS(payment) {
  return payment.name === 'QRIS_ONLINE' || payment.id === 'MIDE_QRIS';
}
